// extracted by mini-css-extract-plugin
export default {"wrapper":"Admin_wrapper__5CxII","content":"Admin_content__mtqAS","usersList":"Admin_usersList__gz8E1"};